module.exports = __webpack_public_path__ + "static/media/circle.fa449f7f.svg";